import {
  Image,
  Description,
  Folder,
  PermPhoneMsg,
  GraphicEq,
  MovieCreation,
  Close,
} from '@material-ui/icons';
import { Modal } from '../../../components/Modal';
import { IconButton } from '../../../components/IconButton';
import { Tooltip } from '../../../components/Tooltip';

interface Props {
  attachments: any[];
  onClose(): void;
  open: boolean;
}

export const ViewAttachmentModal = ({ attachments, onClose, open }: Props) => {
  const getIcon = (extension: any) => {
    switch (extension) {
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'gif':
        return <Image />;
      case 'zip':
        return <Folder />;
      case 'recording':
        return <PermPhoneMsg />;
      case 'mp3':
        return <GraphicEq />;
      case 'mov':
      case 'ts':
        return <MovieCreation />;
      default:
        return <Description />;
    }
  };

  const viewFile = (fileUrl: string) => window.open(fileUrl);

  return (
    <Modal
      open={open}
      onClose={onClose}
      portalOut={document.getElementById('ticket-modal') as Element}
      maxWidth="sm"
      hideCloseButton
    >
      <div className="inline-flex items-center justify-between w-full bg-background-dark py-2 pl-4 pr-2">
        <h5 className="text-lg text-white">Attachments</h5>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </div>
      <ul className="flex flex-col p-4 max-h-[400px] overflow-x-auto gap-2">
        {attachments.map((attachment: any, index: number) => {
          const splitPath = attachment.filename.trim().split('.');
          let extension = splitPath[splitPath.length - 1];
          if (extension.includes('call_recording')) extension = 'recording';

          return (
            <li
              key={`attachment-${index + 1}`}
              className="cursor-pointer flex items-center gap-2 w-full rounded hover:bg-primary"
              onClick={() => viewFile(attachment.url)}
            >
              {getIcon(extension)}
              <Tooltip title="View in new tab" showArrow placement="top">
                <span className="min-w-[100px] max-w-full overflow-hidden whitespace-nowrap text-ellipsis">
                  {attachment.filename}
                </span>
              </Tooltip>
            </li>
          );
        })}
      </ul>
    </Modal>
  );
};
